import { github } from "../config";

export const getRedirectUri = () => {
  return github.redirectUri;
};
